import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";
//import { Accordion, AccordionItem } from 'react-sanfona';
import { Accordion } from "react-bootstrap";

const faqContent = [
  {
    question: "1. What cleaning services do you offer?",
    answer:
      "We offer a wide range of professional cleaning services, including regular residential cleaning, commercial and office cleaning, deep cleaning, move-in/move-out cleaning, and specialized bond cleaning (end-of-lease cleaning).",
  },
  {
    question: "2. Are your cleaners insured and background-checked?",
    answer:
      "Yes, all our professional cleaners are fully insured and have undergone thorough background checks (Police Checks) to ensure the safety and security of your property and peace of mind for our clients.",
  },
  {
    question: "3. Do I need to provide cleaning supplies and equipment?",
    answer:
      "No, we provide all the necessary professional-grade cleaning supplies and high-quality equipment. If you have specific products you would like us to use, please let us know in advance.",
  },
  {
    question: "4. How do I get a quote for my property?",
    answer:
      "You can get a free, no-obligation quote by contacting us through our website's contact form, emailing us at info@kangarooshine.com.au, or calling us directly at 0424 888 804.",
  },
  {
    question: "5. Can I schedule a regular cleaning service?",
    answer:
      "Absolutely! We offer flexible scheduling for recurring services, whether you need weekly, fortnightly, or monthly cleaning. Regular clients often enjoy consistent service from the same professional cleaner.",
  },
  {
    question: "6. Which areas do you serve?",
    answer:
      "We currently provide professional cleaning services across Brisbane, Byron Bay, Tweed Heads, Coffs Harbour, and the Gold Coast region.",
  },
  {
    question: "7. Do you guarantee your bond cleaning service?",
    answer:
      "Yes, our bond cleaning service is designed to meet strict real estate standards. If there are any issues reported by your property manager related to our cleaning checklist, we will return to rectify them at no extra cost.",
  },
  {
    question: "8. How can I pay for my cleaning service?",
    answer:
      "We accept various payment methods, including bank transfers and major credit/debit cards. Payment details will be provided upon booking or completion of the service.",
  },
];

const bg = require("../../images/contactus.png");

const Faq2 = () => {
  const [activeDefault, setActiveDefault] = useState(-1);

  return (
    <>
      <Header />
      <div className="page-content bg-white">
        <div
          className="dlab-bnr-inr overlay-black-middle bg-pt"
          style={{ backgroundImage: "url(" + bg + ")" }}
        >
          <div className="container">
            <div className="dlab-bnr-inr-entry">
              <h1 className="text-white">Faq</h1>
              <div className="breadcrumb-row">
                <ul className="list-inline">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>Faq</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="content-block">
          <div className="section-full content-inner bg-white">
            <div className="container">
              <div className="section-head text-black text-left">
                <h3>General Questions</h3>
              </div>
              <div className="row">
                <div className="col-lg-12 col-sm-12">
                  <Accordion className="dlab-accordion faq-2 box-sort-in m-b30  ">
                    {faqContent.map((faq, i) => (
                      <div className="panel">
                        <Accordion.Item eventKey={`${i}`}>
                          <Accordion.Header as="h6">
                            {faq.question}
                          </Accordion.Header>
                          <Accordion.Body eventKey={`${i}`}>
                            <div>{faq.answer}</div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </div>
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Faq2;
